import script from "./EmpresasList.vue?vue&type=script&setup=true&lang=js"
export * from "./EmpresasList.vue?vue&type=script&setup=true&lang=js"

import "./EmpresasList.vue?vue&type=style&index=0&id=0b8d9502&lang=css"

const __exports__ = script;

export default __exports__